import { useEffect, useState } from 'react';
import './App.css';
import checkMark from './assets/images/check_mark.png';
import checkMarkSuccess from './assets/images/check_mark_success.png';
import shinichi1 from "./assets/images/shinichi1.png";
import shinichi2 from "./assets/images/shinichi2.png";
import shinichi3 from "./assets/images/shinichi3.png";
import shinichi4 from "./assets/images/shinichi4.png";
import shinichi5 from "./assets/images/shinichi5.png";
import shinichi6 from "./assets/images/shinichi6.png";
import shinichi7 from "./assets/images/shinichi7.png";
import shinichi8 from "./assets/images/shinichi8.png";
import shinichi9 from "./assets/images/shinichi9.png";


export const App = () => {
  const [isFailed, setIsFailed] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [selectedImageIds, setSelectedImageIds] = useState([]);
  const answerIds = [1, 5, 8];

  useEffect(() => {
    const itemElements = window.document.getElementsByClassName('recaptcha__body-images__item');
    const itemWidth = itemElements[0].clientWidth;
    for (let i = 0;i < itemElements.length;i++) {
      itemElements[i].style.height = `${itemWidth}px`;
    }
  }, []);

  const clickImage = (imageId) => {
    let newSelectedImageIds = [];
    if (selectedImageIds.includes(imageId)) {
      newSelectedImageIds = selectedImageIds.filter((id) => id !== imageId);
    } else{
      newSelectedImageIds = selectedImageIds.concat([imageId]);
    }
    setSelectedImageIds(newSelectedImageIds);
  }

  const confirm = () => {
    setIsFailed(false);
    if (answerIds.every((id) => selectedImageIds.includes(id)) && selectedImageIds.every((id) => answerIds.includes(id))) {
      setIsSuccess(true);
    } else {
      setIsFailed(true);
    }
  }

  return (
    <div className="App">
      <header className='header'>
        <h1>工藤新一認証</h1>
      </header>
      <div className='main'>
        <div className='inner'>
          <div className='recaptcha'>
            <div className='recaptcha__header'>
              <div className='recaptcha__header-text'>
                <p className='recaptcha__header-text__main'>工藤新一</p>
                <p className='recaptcha__header-text__sub'>の画像をすべて選択してください。</p>
              </div>
            </div>
            <div className='recaptcha__body'>
              <div className='recaptcha__body-images'>
                <div className='recaptcha__body-images__row'>
                  <div className='recaptcha__body-images__item' onClick={() => clickImage(0)}>
                    {selectedImageIds.includes(0) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi1} />
                  </div>
                  <div className='recaptcha__body-images__item' onClick={() => clickImage(1)}>
                    {selectedImageIds.includes(1) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi2} />
                  </div>
                  <div className='recaptcha__body-images__item last' onClick={() => clickImage(2)}>
                    {selectedImageIds.includes(2) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi3} />
                  </div>
                </div>
                <div className='recaptcha__body-images__row'>
                  <div className='recaptcha__body-images__item' onClick={() => clickImage(3)}>
                    {selectedImageIds.includes(3) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi4} />
                  </div>
                  <div className='recaptcha__body-images__item' onClick={() => clickImage(4)}>
                    {selectedImageIds.includes(4) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi5} />
                  </div>
                  <div className='recaptcha__body-images__item last' onClick={() => clickImage(5)}>
                    {selectedImageIds.includes(5) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi6} />
                  </div>
                </div>
                <div className='recaptcha__body-images__row'>
                  <div className='recaptcha__body-images__item' onClick={() => clickImage(6)}>
                    {selectedImageIds.includes(6) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi7} />
                  </div>
                  <div className='recaptcha__body-images__item' onClick={() => clickImage(7)}>
                    {selectedImageIds.includes(7) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi8} />
                  </div>
                  <div className='recaptcha__body-images__item last' onClick={() => clickImage(8)}>
                    {selectedImageIds.includes(8) &&
                      <div className='recaptcha__body-images__item-check'>
                        <img src={checkMark} />
                      </div>
                    }
                    <img src={shinichi9} />
                  </div>
                </div>
              </div>
              {isFailed &&
                <div className='recaptcha__body-text'>
                  <p>もう一度お試しください。</p>
                </div>
              }
            </div>
            <div className='recaptcha__footer'>
              <button className='recaptcha__footer-button' onClick={() => confirm()}>確認</button>
            </div>
          </div>
        </div>
      </div>
      {isSuccess &&
        <div className="modal" id="modal">
          <div className='overlay' onClick={() => setIsSuccess(false)} />
          <div className='modal-wrapper'>
            <div className='modal-contents'>
              <div className="modal-close" onClick={() => setIsSuccess(false)}>✕</div>
              <div className="modal-content">
                <div className='modal-content-image'>
                  <img src={checkMarkSuccess} />
                </div>
                <p>成功</p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}
